<mat-card-header>
  <mat-card-title>Announcements for Audit have been sent</mat-card-title>
</mat-card-header>
<mat-card-content>
  <table
    mat-table
    matSort
    #announcTableComp
    [dataSource]="announceTable.data"
    class="mat-elevation-z8"
    aria-describedby="logs of audit">
    @for (col of announceTable.col; track col) { @if (!col.custom) {
    <ng-container [matColumnDef]="col.field">
      <th
        id="others"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header>
        {{ col.title }}
      </th>
      <td
        mat-cell
        *matCellDef="let row">
        {{ row[col.field] }}
      </td>
    </ng-container>
    } @if (col.custom === 'name') {
    <ng-container [matColumnDef]="col.field">
      <th
        id="name"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header>
        {{ col.title }}
      </th>
      <td
        mat-cell
        *matCellDef="let row">
        {{ row[col.field] }}
      </td>
    </ng-container>
    } }
    <tr
      mat-header-row
      *matHeaderRowDef="colFields(announceTable.col)"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: colFields(announceTable.col)"
      class="item"></tr>
  </table>
</mat-card-content>
